"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _checkIsTouch = _interopRequireDefault(require("@Core/utils/checkIsTouch"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useLinkEventListener = () => {
  (0, _react.useEffect)(() => {
    const isTouch = (0, _checkIsTouch.default)();
    const handleLinkClick = event => {
      if (event.target.tagName.toLowerCase() === "a") {
        const href = event.target.getAttribute("href");
        if (href.startsWith("tel:") || href.startsWith("mailto:")) {
          if (isTouch) {
            event.preventDefault();
            return;
          }
        }
      }
    };
    document.addEventListener("click", handleLinkClick);
    return () => {
      document.removeEventListener("click", handleLinkClick);
    };
  }, []);
};
var _default = exports.default = useLinkEventListener;